/** Join class names; omit falsy. For conflicting Tailwind utilities, order last wins (caller responsibility). */
export function cn(...parts: Array<string | undefined | null | false>): string {
  return parts.filter(Boolean).join(' ');
}
